'use client'
import imgMyself from './icons/myself.svg'
import imgFather from './icons/my_father.svg'
import imgMother from './icons/my_mother.svg'
import imgPartner from './icons/my_partner.svg'
import imgSomeoneElse from './icons/someone_else.svg'
import RadioGroup from '@/src/components/common/RadioGroup'
import bgimage from './bgimage.svg'
import bgimageMobile from './bgimage-mobile.svg'
import Img from '@/src/components/common/Img/Img'
import styles from '../OnboardingForm.module.scss'
import { classNames } from '@/src/helpers/component'
import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'

export default function WhoIsItForForm() {
  const [onboardingData] = useState(readStoredData())

  const options = [
    { icon: imgMyself.src, value: 'Myself' },
    { icon: imgFather.src, value: 'My Father' },
    { icon: imgMother.src, value: 'My Mother' },
    { icon: imgPartner.src, value: 'My Partner' },
    { icon: imgSomeoneElse.src, value: 'Someone Else' },
  ]

  const name = 'who_for'

  return (
    <>
      <div>
        <h3 className={styles.heading}>First of all, who are you looking to support today?</h3>
        <RadioGroup
          required
          options={options}
          name={name}
          value={(onboardingData.data?.[name] || '') as string}
          className={classNames(styles.iconOptions)}
        />
      </div>
      <div>
        <Img src={bgimage.src} className={styles.desktop} />
        <Img src={bgimageMobile.src} className={styles.mobile} />
      </div>
    </>
  )
}
